/** @jsxImportSource @emotion/react */


import { Fragment, useCallback, useContext } from "react"
import { Iconbutton_98348b16bede352a0d51b6c9200c6e68 } from "$/utils/stateful_components"
import { Box as RadixThemesBox, Button as RadixThemesButton, Container as RadixThemesContainer, Flex as RadixThemesFlex, Link as RadixThemesLink, Tabs as RadixThemesTabs } from "@radix-ui/themes"
import { CodeBlock, FlexdownMemo84108 } from "$/utils/components"
import { SemiCircleProgress } from "@mantine/core"
import { EventLoopContext, StateContexts } from "$/utils/context"
import "@mantine/core/styles.css"
import { Event } from "$/utils/state"
import NextLink from "next/link"
import NextHead from "next/head"
import { jsx } from "@emotion/react"



export function Semicircleprogress_e8d74d49b78c3851662c7cc9f3264676 () {
  
  const reflex___state____state__flexdown___modules____5eebaf7317963adcff085d27d99731d16fd6aac491df11600d05cbbae3c8450b____semi_circle_progress_state = useContext(StateContexts.reflex___state____state__flexdown___modules____5eebaf7317963adcff085d27d99731d16fd6aac491df11600d05cbbae3c8450b____semi_circle_progress_state)





  
  return (
    jsx(SemiCircleProgress,{size:100,value:reflex___state____state__flexdown___modules____5eebaf7317963adcff085d27d99731d16fd6aac491df11600d05cbbae3c8450b____semi_circle_progress_state.value},)

  )
}

export function Button_fa9de2f9bec0c02dc9f671465364c10c () {
  
  const [addEvents, connectErrors] = useContext(EventLoopContext);


  const on_click_8e2fc31f8491d92b6eedf84d29315d1f = useCallback(((...args) => (addEvents([(Event("reflex___state____state.flexdown___modules____5eebaf7317963adcff085d27d99731d16fd6aac491df11600d05cbbae3c8450b____semi_circle_progress_state.random", ({  }), ({  })))], args, ({  })))), [addEvents, Event])



  
  return (
    jsx(
RadixThemesButton,
{onClick:on_click_8e2fc31f8491d92b6eedf84d29315d1f},
"Randomize"
,)
  )
}

export default function Component() {
    




  return (
    jsx(
Fragment,
{},
jsx(
"div",
{},
jsx(
"div",
{className:"fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-md border-gray-200 shadow-sm"},
jsx(
"div",
{className:"flex items-center justify-between h-16 px-4 max-w-screen-xl mx-auto"},
jsx(
"div",
{className:"flex items-center space-x-4"},
jsx(
"span",
{className:"text-xl font-bold"},
"Documentation"
,),),jsx(
"div",
{className:"flex items-center space-x-4"},
jsx(Iconbutton_98348b16bede352a0d51b6c9200c6e68,{},)
,),),),jsx(
"div",
{className:"flex min-h-screen"},
jsx(
"div",
{className:"hidden md:block md:w-64 shrink-0 pt-16"},
jsx(
"div",
{className:"w-64 fixed top-16 left-0 h-screen border-r border-gray-200 overflow-y-auto"},
jsx(
"div",
{className:"p-6"},
jsx(
"a",
{href:"/"},
jsx(
"h3",
{className:"text-lg font-bold mb-4"},
"Documentation"
,),),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/built-with-reflex"},
"BuiltWithReflex"
,),jsx(
"div",
{className:"mb-6"},
jsx(
"h4",
{className:"font-semibold mb-2"},
jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid"},
"AgGrid Overview"
,),),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/column-defs"},
"ColumnDefs"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/theme"},
"Theme"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/aligned-grids"},
"Aligned Grids"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/model-wrapper"},
"ModelWrapper"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/pivot-mode"},
"PivotMode"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/undocumented-features-guideline"},
"UndocumentedFeaturesGuideline"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-grid/value-transformers"},
"ValueTransformers"
,),),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/ag-chart"},
"AgChart"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/drag-and-drop"},
"Drag and Drop"
,),jsx(
"div",
{className:"mb-6"},
jsx(
"h4",
{className:"font-semibold mb-2"},
jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/map"},
"Interactive Maps"
,),),),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/single-port-proxy"},
"SinglePortProxy"
,),jsx(
"div",
{className:"mb-6"},
jsx(
"h4",
{className:"font-semibold mb-2"},
jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine"},
"Mantine"
,),),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/autocomplete"},
"Autocomplete"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/collapse"},
"Collapse"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/combobox"},
"Combobox"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/json-input"},
"JSON Input"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/loading-overlay"},
"Loading Overlay"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/multi-select"},
"MultiSelect"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/number-formatter"},
"Number Formatter"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/pill"},
"Pill"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/ring-progress"},
"Ring Progress"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/semi-circle-progress"},
"Semi Circle Progress"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/spoiler"},
"Spoiler"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/tags-input"},
"TagsInput"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/timeline"},
"Timeline"
,),jsx(
"a",
{className:"hover:text-indigo-600 transition-colors duration-200 block py-1 text-sm",href:"/mantine/tree"},
"Tree"
,),),),),),jsx(
"main",
{className:"flex-1 p-10 md:p-12 lg:p-16 overflow-y-auto"},
jsx(
RadixThemesContainer,
{css:({ ["padding"] : "16px" }),size:"3"},
jsx(
Fragment,
{},
jsx(FlexdownMemo84108,{content:"# Semi Circle Progress component\n`rxe.mantine.semi_circle_progress` is a component for displaying progress in a semi-circular format. It is useful for visualizing completion percentages or other metrics in a compact and visually appealing way."},)
,jsx(
RadixThemesTabs.Root,
{css:({ ["&[data-orientation='vertical']"] : ({ ["display"] : "flex" }) }),defaultValue:"tab1"},
jsx(
RadixThemesTabs.List,
{className:"justify-end",css:({ ["&[data-orientation='vertical']"] : ({ ["display"] : "block", ["boxShadow"] : "inset -1px 0 0 0 var(--gray-a5)" }) })},
jsx(
RadixThemesTabs.Trigger,
{className:"tab-style",css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%" }) }),value:"tab1"},
jsx(
RadixThemesBox,
{},
"UI"
,),),jsx(
RadixThemesTabs.Trigger,
{className:"tab-style",css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%" }) }),value:"tab2"},
jsx(
RadixThemesBox,
{},
"Code"
,),),),jsx(
RadixThemesTabs.Content,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%", ["margin"] : null }) }),value:"tab1"},
jsx(
RadixThemesBox,
{className:"my-4"},
jsx(
RadixThemesBox,
{className:"flex flex-col p-6 rounded-xl overflow-x-auto border border-slate-4 bg-slate-2 items-center justify-center w-full"},
jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",direction:"column",gap:"3"},
jsx(Semicircleprogress_e8d74d49b78c3851662c7cc9f3264676,{},)
,jsx(Button_fa9de2f9bec0c02dc9f671465364c10c,{},)
,),),),),jsx(
RadixThemesTabs.Content,
{css:({ ["&[data-orientation='vertical']"] : ({ ["width"] : "100%", ["margin"] : null }) }),value:"tab2"},
jsx(
RadixThemesBox,
{className:"my-4"},
jsx(CodeBlock,{code:"import reflex as rx\nimport reflex_enterprise as rxe\nimport random\n\n\nclass SemiCircleProgressState(rx.State):\n    value: int = 50\n\n    @rx.event\n    def random(self):\n        self.value = random.randint(0, 100)\n\n\ndef semi_circle_progress_example():\n    return rx.vstack(\n        rxe.mantine.semi_circle_progress(\n            size=100,\n            value=SemiCircleProgressState.value,\n        ),\n        rx.button(\n            \"Randomize\",\n            on_click=SemiCircleProgressState.random,\n        ),\n    )",language:"python"},)
,),),),),),),jsx(
"div",
{className:"hidden lg:block md:w-64 shrink-0 pt-16 top-18"},
jsx(
"nav",
{className:"h-screen shrink-0 w-[16%]"},
jsx(
RadixThemesBox,
{css:({ ["@media screen and (min-width: 0)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 30em)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 48em)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 62em)"] : ({ ["display"] : "block" }) })},
jsx(
RadixThemesBox,
{css:({ ["position"] : "fixed", ["display"] : "flex", ["flexDirection"] : "column", ["justifyContent"] : "flex-start", ["gap"] : "0.875rem", ["padding"] : "0.875rem 0.5rem 0 0.5rem", ["width"] : "100%", ["maxWidth"] : "300px", ["maxHeight"] : "80vh", ["overflow"] : "hidden", ["right"] : "0" })},
jsx(
"h5",
{css:({ ["fontWeight"] : "600", ["fontSize"] : "0.7rem", ["color"] : "var(--slate-12)", ["lineHeight"] : "0.5rem", ["letterSpacing"] : "-0.01313rem", ["transition"] : "color 0.2s", ["&:hover"] : ({ ["color"] : "var(--violet-9)" }) })},
"On this page"
,),jsx(
"ul",
{className:"flex flex-col gap-2 list-none"},
jsx(
"li",
{css:({ ["paddingLeft"] : "0rem", ["paddingTop"] : "-0.2rem", ["marginTop"] : "0", ["marginBottom"] : "0", ["paddingBottom"] : "-0.2rem" })},
jsx(
RadixThemesLink,
{asChild:true,css:({ ["fontSize"] : "0.875rem", ["color"] : "var(--slate-9)", ["whiteSpace"] : "nowrap", ["overflow"] : "hidden", ["textOverflow"] : "ellipsis", ["transition"] : "color 0.2s", ["&:hover"] : ({ ["color"] : "var(--slate-11)" }), ["paddingVertical"] : "0rem" }),underline:"none"},
jsx(
NextLink,
{href:"/mantine/semi-circle-progress#semi-circle-progress-component",passHref:true},
"Semi Circle Progress component"
,),),),),),),),),),),jsx(
NextHead,
{},
jsx(
"title",
{},
"Semi Circle Progress"
,),jsx("meta",{content:"favicon.ico",property:"og:image"},)
,),)
  )
}
